import { Typography } from '@mui/material';
import styles from 'features/DefaultHelp.module.css';

const OverviewSection = () => {
    return (
        <>
            <Typography variant="h4">OVERVIEW</Typography>
            <Typography classes={styles['description']} align="justify">
                The Landing Page gives you a high-level snapshot of your facility’s yard operations. It consolidates key insights such as vehicle
                movements, scheduled appointments, authorized personnel, and inventory status. This page is designed to help you quickly assess
                operational activity and prioritize your next actions.
            </Typography>
        </>
    );
};

export default OverviewSection;
